import i18n, {
  loadLanguageAsync,
  getLangObjByCode,
  getLangObjByShowCode
} from '@/i18n'

export default async function (to, from, next) {
  let languageShowCode = to.params.locale
  let langObj = getLangObjByShowCode(languageShowCode)

  if (!langObj) {
    langObj = getLangObjByCode(i18n.locale)
    await loadLanguageAsync(langObj.code)
    return next(langObj.show_code)
  }

  await loadLanguageAsync(langObj.code)
  return next()
}
